module.exports = __webpack_public_path__ + "static/14-bbd5c4f5dbd43746796842afe9feeb0f.png";